import React, { useEffect, useState } from 'react'
import './style/Portfolio.css'
import { FormControl, MenuItem, Select } from '@material-ui/core'
import WorkCard from './Cards/WorkCard'
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

function Portfolio() {

    const [imgs, setImgs] = useState([]);
    const [X, setX]= useState(0);
    const [val, setVal]=useState("All Work");

    useEffect(() => {
        const getData = async () => {
            const data = await fetch(`https://api.unsplash.com/search/photos/?client_id=dCObpMszknUG9_lxPSpP3yqZpHwZ-TS2VPttukcXf3Q&query=${val}`).then(res => res.json());
            setImgs(data.results);
            return data;
        };
        getData();
    }, [val]);



const HandleChange = async (e) => {
    setVal(e.target.value);
    setX(0);
};

const HandleLeft=()=> {
    X!==0?setX(X+250):setX(imgs.length*(-250));
};

const HandleRight=()=> {
    X!==imgs.length*(-250)?setX(X-250):setX(0);
}


    return (
        <div className="portfolio" id="portfolio">
            <div className="portfolio__header">
                <div className="left">
                    <span>Portfolio</span>
                    <h2>Latest Project</h2>
                </div>
                <div className="right">
                <FormControl >
                    <Select value={val} variant="outlined"  onChange={HandleChange}>
                        <MenuItem value="All Work" className="option"><p>All Work</p></MenuItem>
                        <MenuItem value="Men" className="option"><p>Men</p></MenuItem>
                        <MenuItem value="women" className="option"><p>Women</p></MenuItem>
                        <MenuItem value="kids" className="option"><p>Kids</p></MenuItem>
                    </Select>
                </FormControl>
                </div>
            </div>
            <div className="portfolio__work">
                <div className="works" style={{ transform: `translate(${X}px)` }}>
                {
                    imgs.map(data => {
                        return <WorkCard key={data.id} src={data.urls.regular} alt={data.alt_description} title={data.alt_description} desc={data.created_at} url={data.urls.full}/>
                    })
                }
                </div>
                <div className="work__pagination">
                    <ArrowBackIcon onClick={HandleLeft}/>
                    <ArrowForwardIcon onClick={HandleRight}/>
                </div>
            </div>
        </div>
    )
}

export default Portfolio
